import React, { FC, useEffect, useMemo } from 'react';
import Head from 'next/head';
import { useAction } from '@reatom/npm-react';
import { useServices, t, Routes, WeeklyRewards, LearnMode, VIEW_EVENTS } from '@whitesharx/starfall-frontend-core';
import { Learn } from '@whitesharx/starfall-frontend-core/learn_screen';
import '@whitesharx/starfall-frontend-core/learn_screen.css';

import UserInfo from '~/src/components/UserInfo';
import InfoHeader from '~/src/components/InfoHeader';
import PageLayoutHeader from '~/src/components/PageLayoutHeader';
import ChessRoyaleBanner from '~/src/components/ChessRoyaleBanner';
import LearnSkeletonPage from '~/src/skeletons/learn/Learn';

import { AppComponentType, AppTypes } from '../_app';
import { useRouter } from 'next/router';
import { bannerContainerStyles } from '~/styles/pages/common.css';
import CommonCustomApp from '~/src/components/CustomApp/CommonCustomApp';
import { updateRightContainerAction } from '~/src/models/layout';

export const ROUTES_BY_MODE = {
  [LearnMode.LESSON]: Routes.lessons,
  [LearnMode.TRAINING]: Routes.training,
  [LearnMode.BOARD_EDITOR]: Routes.boardEditor,
};

const LearnRealPage: FC = () => {
  const { Adsense, Analytics, useResponsive } = useServices();
  const router = useRouter();
  const { isDesktop } = useResponsive();
  const updateRightContainer = useAction(updateRightContainerAction);

  const rightContainer = useMemo(() => {
    if (isDesktop) {
      return (
        <>
          <UserInfo />
          {Adsense.renderBanner({
            placement: 'puzzles_screen_banner_right', // TODO: change placement
            format: 'rectangle',
            slot: 'bannerRight',
            withSafeMargins: true,
          })}
          <div className={bannerContainerStyles}>
            <ChessRoyaleBanner />
          </div>
        </>
      );
    }
  }, [isDesktop]);

  useEffect(() => {
    updateRightContainer(rightContainer);
  }, [rightContainer]);

  useEffect(() => {
    Analytics.sendEvent(VIEW_EVENTS.learn);
  }, []);

  const onPlay = (mode: LearnMode) => {
    router.push(ROUTES_BY_MODE[mode]);
  };

  return (
    <>
      <Head>
        <title>{t('browser-title.learn')}</title>
      </Head>
      <>
        {!isDesktop && <InfoHeader />}
        <PageLayoutHeader title={t('learn.page-title')} name="learn" />
        <Learn onPlay={onPlay} />
        <WeeklyRewards />
      </>
    </>
  );
};

const LearnPage: FC<AppTypes> & AppComponentType = (props) =>
  props.skeleton ? <LearnSkeletonPage /> : <LearnRealPage {...props} />;

LearnPage.render = (props) => <CommonCustomApp {...props} />;

export default LearnPage;
